var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 6H13C12.4696 6 11.9609 6.21071 11.5858 6.58579C11.2107 6.96086 11 7.46957 11 8V32C11 32.5304 11.2107 33.0391 11.5858 33.4142C11.9609 33.7893 12.4696 34 13 34H24.7L36.448 41.832C36.5986 41.9317 36.7733 41.9887 36.9537 41.9971C37.1341 42.0054 37.3133 41.9648 37.4725 41.8795C37.6316 41.7942 37.7647 41.6674 37.8576 41.5125C37.9504 41.3577 37.9997 41.1806 38 41V34H44C44.5304 34 45.0391 33.7893 45.4142 33.4142C45.7893 33.0391 46 32.5304 46 32V8C46 7.46957 45.7893 6.96086 45.4142 6.58579C45.0391 6.21071 44.5304 6 44 6Z",
    fill: "#E0B23B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9995 0H1.99951C1.46908 0 0.960371 0.210714 0.585298 0.585786C0.210225 0.960859 -0.000488281 1.46957 -0.000488281 2V26C-0.000488281 26.5304 0.210225 27.0391 0.585298 27.4142C0.960371 27.7893 1.46908 28 1.99951 28H7.99951V37C7.99951 37.2652 8.10487 37.5196 8.29241 37.7071C8.47994 37.8946 8.73429 38 8.99951 38C9.20806 38.0005 9.41144 37.9351 9.58051 37.813L23.3195 28H35.9995C36.5299 28 37.0387 27.7893 37.4137 27.4142C37.7888 27.0391 37.9995 26.5304 37.9995 26V2C37.9995 1.46957 37.7888 0.960859 37.4137 0.585786C37.0387 0.210714 36.5299 0 35.9995 0Z",
    fill: "#E0B23B",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.ea98dbb6.svg";
export { ForwardRef as ReactComponent };